import styled, { css } from 'styled-components';

import { IconAwardRibbon, mediaMixin, spaceMixin, token } from '@zillow/constellation';

export const StyledContainer = styled.div<{ backgroundColor?: string; isPremiumTip?: boolean }>`
  padding: ${spaceMixin('md')} ${spaceMixin('sm')};
  border: 1px solid ${token('colors.gray300')};
  border-top: ${({ isPremiumTip }) => isPremiumTip && '3px solid #006AFF'};
  border-radius: 4px;
  background-color: ${(props) => token(`colors.${props.backgroundColor}`)};
  width: 100%;

  ${mediaMixin(
    'md',
    css<{ isPremiumTip?: boolean }>`
      width: ${({ isPremiumTip }) => (isPremiumTip ? '100%' : '294px')};
    `,
  )}

  ${mediaMixin(
    'xl',
    css`
      width: 294px;
    `,
  )}
`;

export const StyledIconAwardRibbon = styled(IconAwardRibbon)`
  vertical-align: middle;
`;
